<template>
  <div v-for="(generalData, gIndex) in formattedGenerals" :key="gIndex">
    <div class="row px-2">
        <div v-for="(heads, keyTitle) in generalData"
             :key="`${gIndex}-${keyTitle}`"
             class="col-12 col-sm-12 col-md-6 col-lg-6 note-section"
        >
            <div class="d-flex align-items-start">
              <input
                class="form-check-input me-2 mt-1"
                type="checkbox"
                :id="`chk-${gIndex}-${keyTitle}`"
                :value="`${gIndex}-${keyTitle}`"
                v-model="selectedTitles"
              />
              <InvestigationCard :tableItems="heads" :title="keyTitle" :isBackground="false" class="flex-grow-1">
                <InvestigationResultTable
                    :tableItems="heads"
                    :antibioticsDrowdown="antibioticsDrowdown"
                />
              </InvestigationCard>
            </div>
        </div>
        </div>
    </div>
</template>

<script setup>
import {ref, watch, onMounted, computed} from 'vue';
import InvestigationCard from '@/components/molecule/company/hospital/investigation-general/InvestigationGeneralCard.vue';
import InvestigationResultTable from '@/components/molecule/company/hospital/investigation-general/InvestigationResultTable.vue';

const props = defineProps({
  formattedGenerals: Object,
  antibioticsDrowdown: Array,
});

const emit = defineEmits(['selection-change']);

const selectedTitles = ref([]);

watch(
    () => props.formattedGenerals,
    (newVal) => {
      const keys = []

      Object.entries(newVal || {}).forEach(([productId, sections]) => {
        Object.keys(sections).forEach(title => {
          keys.push(`${productId}-${title}`)
        })
      })

      selectedTitles.value = keys
    },
    { immediate: true, deep: true }
)

watch(selectedTitles, (newVal) => {
  const selected = {}

  Object.entries(props.formattedGenerals || {}).forEach(([productId, sections]) => {
    Object.entries(sections).forEach(([title, value]) => {
      const key = `${productId}-${title}`
      if (newVal.includes(key)) {
        if (!selected[productId]) selected[productId] = {}
        selected[productId][title] = value
      }
    })
  })

  emit('selection-change', selected)
})
</script>
